import React, { useState, useEffect } from "react";
import axios from "axios";
import { Calendar } from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./Attendance.css";
import api from "../utils/Api";

const Attendance = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [attendanceDetails, setAttendanceDetails] = useState([]);
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
 
  const [attendanceMessage, setAttendanceMessage] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [showCalendar, setShowCalendar] = useState(true);

  const branchId = localStorage.getItem("branchId");
  const enrollId = localStorage.getItem("enrollId");

  // useEffect(() => {
  //   fetchToken(); // Fetch token on mount
  // }, []);

  useEffect(() => {
    // Initialize the current month's fromDate and toDate
    const currentMonthStart = getMonthStart(new Date());
    const currentMonthEnd = getMonthEnd(new Date());
    setFromDate(currentMonthStart);
    setToDate(currentMonthEnd);
  }, []);

  useEffect(() => {
    if (fromDate && toDate) {
      // Fetch attendance details when dates or token are set
      fetchAttendanceDetails(fromDate, toDate);
    }
  }, [fromDate, toDate]);

  

  // const fetchToken = async () => {
  //   try {
  //     const fd = new FormData();
  //     fd.append("programType", "getToken");

  //     const response = await api.post("/token/tokenCurl", fd);

  //     if (response.data.success) {
  //       setToken(response.data.data);
  //     } else {
  //       console.error("Error fetching token:", response.data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching token:", error);
  //   }
  // };

  const calculateAttendanceTotals = () => {
    const filteredDetails = attendanceDetails.filter(entry => entry.status !== "NA");
    const totalPresent = filteredDetails.filter((entry) => entry.status === "P").length;
    const totalAbsent = filteredDetails.filter((entry) => entry.status === "A").length;
    return { totalPresent, totalAbsent };
  };
  

  const fetchAttendanceDetails = async (fromDate, toDate) => {
    
    const token = localStorage.getItem("authToken");
    const enrollId = localStorage.getItem("enrollId");
    const branchId = localStorage.getItem("branchId");

    const fd = new FormData();
    fd.append("programType", "getStudentAttendance");
    fd.append("authToken", token);
   
    fd.append("branch", branchId);
    fd.append("enrollId", enrollId);
    fd.append("fromDate", fromDate);
    fd.append("toDate", toDate);
    for (let pair of fd.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }
    // console.log("branch", branchId)
    // console.log("authToken", token)

    // console.log("fromDate", fromDate)
    // console.log("toDate", toDate)

    try {
      const response = await api.post("parentApp/studentCurl2", fd);
      console.log("attendance", response)
      const data = response.data.data || [];
      // console.log("attendance", data)
      setAttendanceDetails(data);
    } catch (error) {
      console.error("Error fetching attendance details:", error);
    }
  };

  const getMonthStart = (date) => {
    const start = new Date(date.getFullYear(), date.getMonth(), 1);
    return start.toISOString().split("T")[0];
  };

  const getMonthEnd = (date) => {
    const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return end.toISOString().split("T")[0];
  };

  const handleDateClick = (date) => {
    setSelectedDate(date);
    const selectedDateStr = formatDate(date);
  
    const attendance = attendanceDetails.find(
      (entry) => formatDate(new Date(entry.date)) === selectedDateStr
    );
  
    if (attendance) {
      if (attendance.status === "P") {
        setAttendanceMessage("The Student was present");
      } else if (attendance.status === "A") {
        setAttendanceMessage("The Student was absent");
      } else if (attendance.status === "NA") {
        setAttendanceMessage("No attendance recorded for this day");
      }
    } else {
      setAttendanceMessage("No attendance data found");
    }
  
    setShowDetails(true);
  };
  

  const onCalendarNavigate = (activeStartDate) => {
    const newFromDate = getMonthStart(activeStartDate);
    const newToDate = getMonthEnd(activeStartDate);
    setFromDate(newFromDate);
    setToDate(newToDate);
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const tileClassName = ({ date, view }) => {
    if (view === "month") {
      const isWithinActiveMonth = date >= new Date(fromDate) && date <= new Date(toDate);
  
      if (isWithinActiveMonth) {
        const dateStr = formatDate(date);
        const attendance = attendanceDetails.find(
          (entry) => formatDate(new Date(entry.date)) === dateStr && entry.status !== "NA"
        );
        if (attendance) {
          return attendance.status === "P" ? "present" : "absent";
        }
      }
  
      // Highlight Sundays
      if (date.getDay() === 0 && !isDateDisabled(date)) {
        return "sunday";
      }
    }
    return "";
  };
  

  // Helper function to check if a date is disabled
  const isDateDisabled = (date) => {
    return date < new Date(fromDate) || date > new Date(toDate);
  };

  const tileContent = ({ date, view }) => {
    if (view === "month") {
      const isWithinActiveMonth = date >= new Date(fromDate) && date <= new Date(toDate);
  
      if (isWithinActiveMonth) {
        const dateStr = formatDate(date);
        const attendance = attendanceDetails.find(
          (entry) => formatDate(new Date(entry.date)) === dateStr && entry.status !== "NA"
        );
  
        if (attendance) {
          return (
            <div className="tile-content">
              <div
                className={`dot ${attendance.status === "P" ? "present" : "absent"}`}
              ></div>
            </div>
          );
        }
  
        // If it's Sunday and not a disabled date, show a gray dot
        if (date.getDay() === 0) {
          return (
            <div className="tile-content">
              <div className="dot sunday-dot"></div>
            </div>
          );
        }
      }
    }
    return null;
  };
  

  return (
    <div className="page-content-wrapper py-3">
      <div className="container " style={{ marginTop: "50px" }}>
        <h2 className="page-title text-center" style={{ marginBottom: "30px" }}>
          Attendance
        </h2>
        <div className="card mb-3 shadow-sm ">
          <div className="card-body">
            {showCalendar && (
              <div
                className="calendar-container"
                style={{ border: "none", width: "auto" }}
              >
                <Calendar
                  onChange={handleDateClick}
                  onActiveStartDateChange={({ activeStartDate }) =>
                    onCalendarNavigate(activeStartDate)
                  }
                  value={selectedDate}
                  tileClassName={tileClassName}
                  tileContent={tileContent}
                  formatShortWeekday={(locale, date) => date.toLocaleDateString(locale, { weekday: "narrow" })}
                  formatMonthYear={(locale, date) => date.toLocaleDateString(locale, { month: "short", year: "numeric" })}
                />
              </div>
            )}
          </div>
        </div>

        <div className="legend-container text-center mt-3">
          <div className="legend">
            <span className="dot present"></span> Present
            <span className="dot absent" style={{ marginLeft: "15px" }}></span> Absent
            <span className="dot sunday-dot" style={{ marginLeft: "15px" }}></span> Holiday
          </div>
        </div>

        <div className="card user-data-card mt-2 mb-5 ">
  {attendanceDetails.length > 0 && (
    (() => {
      const { totalPresent, totalAbsent } = calculateAttendanceTotals();
      return (
        <div className="card-body d-flex justify-content-around p-3 rounded shadow-md  text-center">
          <div className="">
            <p className="mb-1 text-success fw-bold">Total Present</p>
            <h5 className="mb-0 fw-bold">{totalPresent}</h5>
          </div>
          <div>
            <p className="mb-1 text-danger fw-bold">Total Absent</p>
            <h5 className="mb-0 fw-bold">{totalAbsent}</h5>
          </div>
        </div>
      );
    })()
  )}
</div>


        {showDetails && (
          <div className="mt-3">
            <h4 className="page-title">Attendance Details</h4>
            <p>{attendanceMessage}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Attendance;
